/* globals jQuery */
import 'fitvids.1.1.0'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

import Swiper from 'swiper';
import {A11y, FreeMode} from 'swiper/modules';

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas',
        closeOnOutsideClick: true
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    var swiper = new Swiper(".swiper", {
        modules: [A11y,FreeMode],
        slidesPerView: 1,
        initialSlide: 1,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            650: {
                slidesPerView: 2,
                initialSlide: 1
            },
            768: {
                slidesPerView: 3,
                initialSlide: 0
            },
            1024: {
                slidesPerView: 4,
                initialSlide: 0
            }

        }
    });


})(jQuery)
